import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ConditionSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ConditionSVG;
